export const PASSKEYS_KB_URL = 'https://knowledge.hubspot.com/account-management/set-up-and-log-in-with-passkeys';